import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AgreementProvider,
  useAgreement,
} from '../../contexts/AgreementsContext';

const AgreementCheckContent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { hasExpiredAgreements, checkAgreements } = useAgreement();
  const navigate = useNavigate();

  useEffect(() => {
    checkAgreements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  useEffect(() => {
    if (hasExpiredAgreements) {
      navigate('/agreements/renewal', { replace: true });
    }
  }, [hasExpiredAgreements, navigate]);

  return <>{children}</>;
};

export const AgreementCheck: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <AgreementProvider>
      <AgreementCheckContent>{children}</AgreementCheckContent>
    </AgreementProvider>
  );
};
